module.exports = __webpack_public_path__ + "32d8f8f859717151e338f80bb0d5e6d0.pdf";